(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  (function enableHeaderMenuHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('header-drawer').forEach((drawer) => {
      const details = drawer.querySelector('details.menu-drawer-container');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      const header = document.querySelector('.section-header');
      const wrapper = drawer.closest('.header-wrapper');

      const setHeaderBottom = () => {
        const borderOffset = wrapper && wrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        if (header) {
          document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(header.getBoundingClientRect().bottom - borderOffset, 10)}px`
          );
        }
      };

      drawer.addEventListener('mouseenter', () => {
        if (details.hasAttribute('open')) return;
        setHeaderBottom();
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded', 'true');
        if (header) header.classList.add('menu-open');
      });

      drawer.addEventListener('mouseleave', () => {
        if (!details.hasAttribute('open')) return;
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        if (header) header.classList.remove('menu-open');
        drawer.querySelectorAll('.menu-drawer__menu details').forEach((nested) => {
          nested.removeAttribute('open');
          nested.classList.remove('menu-opening');
          nested.closest('.has-submenu')?.classList.remove('submenu-open');
          const nestedSubmenu = nested.querySelector(':scope > .menu-drawer__submenu');
          if (nestedSubmenu) nestedSubmenu.removeAttribute('style');
        });
      });

      const placeFlyout = (itemDetails) => {
        const submenu = itemDetails.querySelector(':scope > .menu-drawer__submenu');
        const panel = drawer.querySelector('#menu-drawer');
        if (!submenu || !panel) return;
        const rect = panel.getBoundingClientRect();
        submenu.style.setProperty('position', 'fixed', 'important');
        submenu.style.setProperty('top', `${Math.round(rect.top)}px`, 'important');
        submenu.style.setProperty('left', `${Math.round(rect.right)}px`, 'important');
        submenu.style.setProperty('right', 'auto', 'important');
        submenu.style.setProperty('bottom', 'auto', 'important');
        submenu.style.setProperty('width', '26rem', 'important');
        submenu.style.setProperty('height', 'auto', 'important');
        submenu.style.setProperty('transform', 'none', 'important');
        submenu.style.setProperty('visibility', 'visible', 'important');
        submenu.style.setProperty('z-index', '40', 'important');
      };

      const clearFlyout = (itemDetails) => {
        const submenu = itemDetails.querySelector(':scope > .menu-drawer__submenu');
        if (!submenu) return;
        submenu.removeAttribute('style');
      };

      drawer.querySelectorAll('.menu-drawer__menu > li > details').forEach((itemDetails) => {
        const item = itemDetails.parentElement;
        const itemSummary = itemDetails.querySelector('summary');

        if (itemSummary) {
          itemSummary.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
          });
        }

        item.addEventListener('mouseenter', () => {
          drawer.querySelectorAll('.menu-drawer__menu > li > details').forEach((other) => {
            if (other === itemDetails) return;
            other.removeAttribute('open');
            other.classList.remove('menu-opening');
            other.closest('.has-submenu')?.classList.remove('submenu-open');
            clearFlyout(other);
          });
          itemDetails.setAttribute('open', '');
          itemDetails.classList.add('menu-opening');
          itemDetails.closest('.has-submenu')?.classList.remove('submenu-open');
          placeFlyout(itemDetails);
        });

        item.addEventListener('mouseleave', (event) => {
          const submenu = itemDetails.querySelector(':scope > .menu-drawer__submenu');
          const next = event.relatedTarget;
          if (submenu && next && submenu.contains(next)) return;
          itemDetails.removeAttribute('open');
          itemDetails.classList.remove('menu-opening');
          itemDetails.closest('.has-submenu')?.classList.remove('submenu-open');
          clearFlyout(itemDetails);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
